// extracted by mini-css-extract-plugin
export default {"alphabetWrapper":"XJXzvV99","switchInnerWrapper":"qLoRJEyR","switchWrapper":"a4AfT4v5","_isOpened":"Tl3Ccbas","charButtonWrapper":"poglyCai","switchButtonWrapper":"qqbke_0P"};